import React, { useState } from "react";
import { Modal, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import EditVarietyModalContent from "./EditVarietyModalContent";

const VarietyIconGroup = ({
  varietyLabel,
  variety,
  updateCallback,
  deleteCallback,
  allOrgs,
  allSites,
  allCrops,
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);

  const handleEditCancel = () => {
    setEditModalOpen(false);
  };

  const handleDelete = () => {
    deleteCallback(variety.id);
  };

  return (
    <div className="flex items-center">
      {/* Edit Icon */}
      <EditOutlined
        className="pr-2 cursor-pointer text-primaryBlue"
        onClick={() => setEditModalOpen(true)}
      />

      {/* Delete Icon with Confirmation */}
      <Popconfirm
        title={"Are you sure you want to delete this " + varietyLabel + "?"}
        onConfirm={handleDelete}
        okText="Yes"
        cancelText="No"
        placement="topRight"
      >
        <DeleteOutlined className="cursor-pointer text-dangerRed" />
      </Popconfirm>

      {/* Edit Variety Modal */}
      <Modal
        maskClosable={false}
        title={
          <div className="mb-5 font-IBMPlexSansBold text-2xl">
            Edit {varietyLabel}
          </div>
        }
        open={editModalOpen}
        onCancel={handleEditCancel}
        footer={null}
      >
        <EditVarietyModalContent
          varietyLabel={varietyLabel}
          setOpen={setEditModalOpen}
          data={variety}
          updateCallback={updateCallback}
          allOrgs={allOrgs}
          allSites={allSites}
          allCrops={allCrops}
        />
      </Modal>
    </div>
  );
};

export default VarietyIconGroup;
